import { type Editor } from "@tiptap/react";
import { type MouseEvent, type ReactNode, useRef } from "react";
import { cx } from "shared/utils";

interface EditorContainerProps {
  children: ReactNode;
  editor: Editor;
  editorContainerClassName: string;
  id: string;
  isTouchDevice: boolean;
}

export const EditorContainer = (props: EditorContainerProps) => {
  const { children, editor, editorContainerClassName, id } = props;

  const containerRef = useRef<HTMLDivElement>(null);

  const handleContainerClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if (event.target !== event.currentTarget) return;
    if (!editor.isEditable) return;
    try {
      if (editor.isFocused) return; // If editor is already focused, do nothing

      editor.chain().focus("end", { scrollIntoView: false }).run(); // Focus the editor at the end
    } catch (error) {
      console.error(
        "An error occurred while handling container click to insert new empty node at bottom:",
        error
      );
    }
  };

  const handleContainerMouseLeave = () => {
    const dragHandleElement = document.querySelector("#editor-side-menu");
    if (!dragHandleElement?.classList.contains("side-menu-hidden"))
      dragHandleElement?.classList.add("side-menu-hidden");
  };

  return (
    <div
      ref={containerRef}
      id={`editor-container-${id}`}
      onClick={(event) => {
        handleContainerClick(
          event as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>
        );
      }}
      onMouseLeave={handleContainerMouseLeave}
      className={cx(
        `editor-container cursor-text relative`,
        editor.isFocused && editor.isEditable ? "active-editor" : "",
        editorContainerClassName
      )}
    >
      {children}
    </div>
  );
};
